import { usageId } from "../../constants/usageid.js";
import { DomainSchemaIds, DomainTags } from "../../schemas/domain.const.js";
export const dictionary = {
    schema: {
        // [DomainSchemaIds_deprecated.DOMAIN]: {
        //   title: 'Domain',
        //   description: 'A client domain.',
        // },
        // [DomainSchemaIds_deprecated.DOMAIN_LIST]: {
        //   title: 'List of domains',
        //   description: 'A list of client domains.',
        // },
        // [DomainSchemaIds_deprecated.RESELLER_DOMAIN_FILTER]: {
        //   title: 'Reseller domain filter',
        //   description: 'Collection of optional values where to filter on.',
        // },
        // [DomainSchemaIds_deprecated.DOMAIN_FILTER]: {
        //   title: 'Domain filter',
        //   description: 'Collection of optional values where to filter on.',
        // },
        // [DomainSchemaIds_deprecated.CREATE_DOMAIN]: {
        //   title: 'Domain to create',
        //   description: 'Details of the to be created domain.',
        // },
        // [DomainSchemaIds_deprecated.CREATE_RESELLER_DOMAIN]: {
        //   title: 'Domain name and title',
        //   description:
        //     'The name and title for a new domain managed by a  reseller organisation.',
        // },
        // [DomainSchemaIds_deprecated.UPDATE_DOMAIN]: {
        //   title: 'Domain properties to update',
        //   description: 'Collection of optional properties to update on a domain.',
        // },
        [usageId(DomainSchemaIds.DOMAIN, DomainTags.AS_TEAM)]: {
            title: 'Atlas',
            description: 'An atlas managed by a reseller.',
        },
        [usageId(DomainSchemaIds.DOMAIN, DomainTags.AS_ACCOUNT)]: {
            title: 'Atlas',
            description: 'A client\'s atlas.',
        },
    },
};
